import {withInstall} from "@verdure/core";
// @ts-ignore
import TPayOrderLog from './src/Index.vue'

// 微信订单支付日志列表
TPayOrderLog.name = 'verdure-wechat-pay-order-log';
export const WechatPayOrderLog = withInstall(TPayOrderLog);

